export default __webpack_public_path__ + "static/media/logout.37e35c19.png";